import api from 'lib/api'
import type { Filter } from 'lib/store'

interface DataVacancy {
  count: number
  currentPage: number
  data: any[]
  totalPages: number
}

export const getVacancies = async (
  filter: Filter,
  slug: string
): Promise<DataVacancy> => {
  try {
    const params = { take: 12, ...filter }
    const response = await api<DataVacancy>(
      `/companies/${encodeURIComponent(slug)}/vacancies`,
      { params }
    )

    if (response.data?.data) {
      return response.data
    }
  } catch (err) {
    console.log(err)
  }

  return { count: 0, currentPage: 0, data: [], totalPages: 0 }
}

export type VacancyApplied = 'pre-applied' | 'applied' | ''

const hasApplied = async (vacancyId: number): Promise<boolean> => {
  try {
    const response = await api<{ applied: boolean }>(
      '/selective-process/vacancy/' + vacancyId,
      {},
      'applicants'
    )

    return !!response.data.applied
  } catch (err) {
    console.error(err)
  }

  return false
}

// A API só devolve `preApplied` quando a requisição é autenticada, e a página
// da vaga é gerada por ISR (cache compartilhado, sem token). Por isso a
// pré-candidatura é consultada aqui, no client: sem essa chamada o estado
// existiria apenas no cache do React Query e o botão de candidatura voltaria a
// aparecer a cada recarregamento.
const hasPreApplied = async (vacancyId: number): Promise<boolean> => {
  try {
    const response = await api<{ preApplied?: boolean }>(
      '/vacancies/' + vacancyId
    )

    return !!response.data.preApplied
  } catch (err) {
    console.error(err)
  }

  return false
}

export const getVacancyApplied = async (
  vacancyId: number
): Promise<VacancyApplied> => {
  const [applied, preApplied] = await Promise.all([
    hasApplied(vacancyId),
    hasPreApplied(vacancyId)
  ])

  // `applied` tem precedência: quem pré-candidatou e depois concluiu a
  // candidatura completa continua com `preApplied` marcado na API
  if (applied) {
    return 'applied'
  }

  if (preApplied) {
    return 'pre-applied'
  }

  return ''
}

export const getCitiesInVacancies = async (slug: string): Promise<string[]> => {
  try {
    const response = await api<{ name: string }[]>(
      `/companies/${encodeURIComponent(slug)}/locations`
    )

    const cities = response.data.map(item => item.name)

    return ['Todos', ...cities]
  } catch (err) {
    console.log(err)
  }

  return []
}
